// packages Import
import { Paper, Table, TableContainer } from "@mui/material";
import { FC } from "react";
import { TableHeaderProps } from "../../interfaceTypes";
export const StickyTable: FC<TableHeaderProps> = ({ children, pagination, height }): JSX.Element => {

  return (<Paper sx={{ width: '100%', overflow: 'hidden' }}>
    <TableContainer sx={{ height: `calc(100vh - ${height || '342px'})` }}>
      <Table stickyHeader aria-label="sticky table">
        {children}
      </Table>
    </TableContainer>
    {pagination}
  </Paper>
  )
}